import { render, staticRenderFns } from "./IphLogo.vue?vue&type=template&id=02e41015&"
import script from "./IphLogo.vue?vue&type=script&lang=js&"
export * from "./IphLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports